<script setup lang="ts">
const route = useRoute();
const currencyStore = useCurrencyStore();

const {
  value,
  label = "1 night",
  valueType = "dates",
} = defineProps<{
  value?: string;
  label?: string;
  valueType?: "dates" | "price" | "priceEdit" | "datesEdit";
}>();

const isPaymentQuery = computed(() => route.fullPath.includes("/payment"));
</script>

<template>
  <div class="selected-dates">
    <div class="dates small">
      <span v-if="valueType === 'dates' || valueType === 'datesEdit'">{{
        value
      }}</span>
      <Price
        v-if="valueType === 'price' || valueType === 'priceEdit'"
        :price="value"
        :force-currency="currencyStore.selectedCurrency"
        :force-property-currency="currencyStore.hotelOfferCurrency || 'USD'"
      />
      <button
        v-if="
          isPaymentQuery ||
          valueType === 'priceEdit' ||
          valueType === 'datesEdit'
        "
        type="button"
      >
        <IconPencilSmallIcon />
      </button>
      <button v-if="valueType === 'price'" type="button">
        <IconInfoHelp />
      </button>
    </div>
    <div class="nights smaller">
      {{ label }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.selected-dates {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--space-20) 0 var(--space-4) var(--space-16);
}

.dates {
  display: flex;
  align-items: center;
  font-family: var(--font-family-bold);
}

button {
  flex-shrink: 0;
  width: 20px;
  min-width: 20px;
  height: 20px;
  margin: 0 0 0 var(--space-8);
}

.nights {
  color: var(--color-inactive-black);
}
</style>
